<script>
export default {
  name: 'Modal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'modal-xl'
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    confirmText: {
      type: String,
      default: 'Aceptar'
    },
    cancelText: {
      type: String,
      default: 'Cancelar'
    }
  },
  methods: {
    close() {
      this.$emit('update:isVisible', false)
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
      this.close()
    },
    onOverlayClick(event) {
      if (event.target === event.currentTarget) {
        this.close()
      }
    }
  }
}
</script>

<template>
  <transition name="modal-fade">
    <div v-if="isVisible" class="modal-overlay" @click="onOverlayClick">
      <div class="modal-dialog mh-100" :class="size">
        <div class="modal-content">
          <header class="modal-header d-flex justify-content-between py-2 px-4 border-bottom" v-if="showHeader">
            <slot name="header">
              <h1 class="color-main modal-title fs-4 fw-bold">{{ title }}</h1>
              <button type="button" class="btn-close fs-4" @click="close"></button>
            </slot>
          </header>
          <main class="modal-body">
            <slot/>
          </main>
          <footer class="modal-footer py-2 px-4 gap-2 border-top" v-if="showFooter">
            <slot name="footer">
              <button
                type="button"
                class="btn modal-btn modal-footer__button modal-footer__button-cancel"
                @click="close"
              >
                {{ cancelText }}
              </button>
              <button
                v-if="showConfirm"
                type="button"
                class="btn modal-btn modal-footer__button modal-footer__button-accept"
                @click="confirm"
              >
                {{ confirmText }}
              </button>
            </slot>
          </footer>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-dialog {
  background-color: #fff;
  border-radius: 15px;
  position: relative;
  z-index: 1050;
  overflow: hidden;
  min-width: 300px;
  max-width: 100%;
  max-height: 96vh; // Añadido para limitar altura
  display: flex; // Añadido
}

.modal-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 96vh;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
}

.modal-header,
.modal-footer {
  flex-shrink: 0; // Evita que el header y footer se encojan
}
</style>
